export default __webpack_public_path__ + "static/media/TOS_symbol.62e0334b.svg";